import React, { useState } from "react";
import { TextField, Button, CircularProgress } from "@mui/material";
import { Formik, Form, ErrorMessage } from "formik";
import validationSchema from "./schema";
import { register } from "../../services/auth";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { getUserById } from "../../services/user";
import PasswordField from "../PasswordField";
const RegisterForm = ({ companyId, email }) => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const initialValues = {
    firstName: "",
    lastName: "",
    email: email || "",
    password: "",
  };

  const handleSubmit = async (values) => {
    setIsLoading(true);
    const userInfo = {
      email: values.email,
      profile: {
        firstname: values.firstName,
        lastname: values.lastName,
      },
      password: values.password,
      companyId: companyId || null,
    };

    await register(userInfo)
      .catch((error) => {
        console.error("Error registering:", error);
        toast.error(error.response.data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      })
      .then(async (response) => {
        setIsLoading(false);
        const userProfile = await getUserById(response.userId);
        navigate("/form-workspace", { state: { profile: userProfile } });
      });

    // Luego, podrías redirigir al usuario a otra página, si es necesario
  };
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({
        values,
        handleChange,
        handleBlur,
        handleSubmit,
        errors,
        touched,
      }) => (
        <Form onSubmit={handleSubmit}>
          <TextField
            name="firstName"
            label="Nombre"
            variant="outlined"
            fullWidth
            value={values.firstName}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.firstName && !!errors.firstName}
            helperText={<ErrorMessage name="firstName" />}
            style={{ marginBottom: "16px" }}
          />
          <TextField
            name="lastName"
            label="Apellido"
            variant="outlined"
            fullWidth
            value={values.lastName}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.lastName && !!errors.lastName}
            helperText={<ErrorMessage name="lastName" />}
            style={{ marginBottom: "16px" }}
          />
          <TextField
            name="email"
            label="Correo Electrónico"
            variant="outlined"
            fullWidth
            value={values.email}
            onChange={handleChange}
            onBlur={handleBlur}
            disabled={email ? true : false}
            error={touched.email && !!errors.email}
            helperText={<ErrorMessage name="email" />}
            style={{ marginBottom: "16px" }}
          />
          <PasswordField
            name="password"
            placeholder="Contraseña"
            variant="outlined"
            fullWidth
            id="password"
            label="Contraseña"
            autoComplete="current-password"
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.password && !!errors.password}
            helperText={<ErrorMessage name="password" />}
            style={{ marginBottom: "16px" }}
          />

          {isLoading ? (
            <CircularProgress />
          ) : (
            <Button type="submit" fullWidth variant="contained" color="primary">
              Crear Cuenta
            </Button>
          )}
        </Form>
      )}
    </Formik>
  );
};

export default RegisterForm;
